import { configureCompat } from 'vue';
import Multiselect from 'vue-multiselect';

// Components written for Vue 3 keep all their state in setup(): Vuetify, bootstrap-vue-next,
// v-calendar and our own <script setup> components. Our Vue 2 style components declare data,
// methods, computed or watch. In Vue 2 mode, compat rewrites a Vue 3 component's
// modelValue/update:modelValue to value/input, which it ignores, and skips its class/style in $attrs.
function isSetupOnlyComponent(component) {
	return typeof component?.setup === 'function'
		&& !component.data
		&& !component.methods
		&& !component.computed
		&& !component.watch
		&& !component.mixins;
}

// With COMPONENT_ASYNC off, a plain-function component is a Vue 3 functional component, such as
// Vuetify's MaybeTransition. Vue 2 mode leaves class and style out of its props, so the
// v-messages class never reached the field messages and error text lost its colour.
function isFunctionalComponent(component) {
	return typeof component === 'function';
}

// vue compat migration warnings
configureCompat({
	MODE: (component) => isSetupOnlyComponent(component) || isFunctionalComponent(component) ? 3 : 2,
	ATTR_FALSE_VALUE: 'suppress-warning',
	ATTR_ENUMERATED_COERCION: false,
	// Off so plain-function components (e.g. Vuetify's LoaderSlot) render as Vue 3
	// functional components instead of being called as Vue 2 async factories
	COMPONENT_ASYNC: false,
	// COMPONENT_V_MODEL and INSTANCE_ATTRS_CLASS_STYLE are left unset, so they stay on for Vue 2 mode
	// components and off for Vue 3 mode ones. 'suppress-warning' would turn them on in both modes.
	INSTANCE_EVENT_EMITTER: 'suppress-warning',
	OPTIONS_BEFORE_DESTROY: 'suppress-warning',
	OPTIONS_DATA_MERGE: 'suppress-warning',
	RENDER_FUNCTION: 'suppress-warning',
	WATCH_ARRAY: 'suppress-warning',
});

// vue-multiselect sets ATTR_ENUMERATED_COERCION: false on itself, which overrides the setting above,
// so compat warns about its :spellcheck="false" on every render. Both modes render spellcheck="false".
Multiselect.compatConfig.ATTR_ENUMERATED_COERCION = 'suppress-warning';
